import { TypeCustomSchemaFields } from '@/core/generated-types';
import Script from 'next/script';
import React, { FC } from 'react';

const CustomSchema: FC<TypeCustomSchemaFields> = ({
  tagHtml,
  placement,
  entryName,
}) => {
  if (placement === 'head') {
    return (
      <Script
        type="application/ld+json"
        id={entryName}
        data-testid={`custom-schema-${entryName}`}
        dangerouslySetInnerHTML={{
          __html: tagHtml,
        }}
      />
    );
  }

  return (
    <div
      data-testid={`custom-schema-${entryName}`}
      dangerouslySetInnerHTML={{ __html: tagHtml }}
    />
  );
};

export default React.memo(CustomSchema);
